// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"186":"4716092d","223":"3195c75b","224":"1f1913e8","273":"85a74a25","294":"3a6d33f7","369":"63b87be4","468":"1bc63456","565":"85363e78","646":"63819959","710":"3db81daa","728":"73d53f01"}[chunkId] + ".chunk.js";
};